// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store'

// import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'

import DateDropdown from 'vue-date-dropdown'
import VueTimepicker from 'vue2-timepicker'

import responsive from 'vue-responsive'
import '@/assets/styles/style.css'

import Toasted from 'vue-toasted'

// import '@/assets/styles/landing-page.css'
// import '@/assets/styles/dashboard.css'
// import '@/assets/styles/create-style.css'

Vue.use(Toasted)

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

Vue.use(DateDropdown)
Vue.use(VueTimepicker)

Vue.use(responsive)

Vue.config.productionTip = false
Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  // Define common validation messages.
  messages: {
    required: "{attribute} is required.",
    email: "Please submit a valid Email address.",
    isCorrectMobileNumberFormat: "Mobile Number should be in this format: 0922XXXXXX.",
    numeric: "Only numbers are allowed.",
    alphaSpace: "Please write your {attribute} in words. Numbers are not allowed.",
    hasReached250Characters: "You have exceeded character limit. Max of 250 characters is allowed."
  }
})

Vue.component('form-group', templates.singleErrorExtractor.bootstrap3)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js